import { Clock } from "lucide-react";

const money = (v) => `R$ ${Number(v || 0).toFixed(2).replace(".", ",")}`;

export default function UltimasCompras({ compras = [], compact = false }) {
  if (!compras || compras.length === 0) {
    return (
      <div className="text-xs text-neutral-500 italic">
        Nenhuma compra registrada ainda.
      </div>
    );
  }
  return (
    <div className="space-y-1.5">
      <div className="font-mono text-[10px] uppercase tracking-widest text-neutral-500 flex items-center gap-1">
        <Clock className="w-3 h-3" /> Últimas {compras.length}{" "}
        {compras.length === 1 ? "compra" : "compras"}
      </div>
      <ol className="space-y-1">
        {compras.map((v, idx) => {
          const dt = new Date(v.data_venda);
          const dataStr = dt.toLocaleDateString("pt-BR");
          const horaStr = dt.toLocaleTimeString("pt-BR", {
            hour: "2-digit",
            minute: "2-digit",
          });
          return (
            <li
              key={v.venda_id}
              data-testid={`ultimas-compra-${idx}`}
              className="border border-neutral-300 px-2 py-1.5 bg-white text-xs"
            >
              <div className="flex items-center justify-between gap-2">
                <span className="font-mono font-bold">
                  {dataStr} · {horaStr}
                </span>
                <span className="font-mono font-bold">{money(v.total_liquido)}</span>
              </div>
              {!compact && v.itens?.length > 0 && (
                <div className="text-neutral-600 mt-0.5 leading-tight">
                  {v.itens
                    .map((i) => `${i.quantidade}x ${i.nome}`)
                    .join(" · ")}
                </div>
              )}
            </li>
          );
        })}
      </ol>
    </div>
  );
}
